import type { CustomerDetailsPayload } from "@expert/sales-tools";

export type NameMatchResult = "NoCustomerFound" | "ExistingCustomerNameSelected" | "NewCustomerNameAdded";

/**
 * Compares the entered customer name against the primary account holder and authorized users.
 * Returns a string indicating the match status for analytics purposes.
 */
export function compareName(
    customerData: CustomerDetailsPayload | undefined,
    customerName: string | undefined,
): NameMatchResult {
    if (customerData?.primaryAccountHolder?.fullName === undefined) {
        return "NoCustomerFound";
    }

    if (
        customerData.primaryAccountHolder.fullName === customerName ||
        customerData.authorizedUsers?.find((user) => user.fullName === customerName)
    ) {
        return "ExistingCustomerNameSelected";
    }

    return "NewCustomerNameAdded";
}
